<app-dropdown-select
	[tooltip]="control.valid ? 'Listing Type' : 'Required'"
	[control]="control"
	[options]="listingClassOptions"
	[label]="'Type'"
	[multiple]="true"
	[dropdownToggleClass]="control.valid ? '' : 'text-danger'"
	dropdownMenuClass="checkbox-dropdown"
></app-dropdown-select>
